import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { SelectProductBaseVariantOverlayProps } from "../SelectProductBaseVariantOverlay"
import { SelectProductBaseVariantOverlayViewModel } from "../SelectProductBaseVariantOverlayView"

export function useSelectProductBaseVariantOverlayViewModel({
  payload
}: SelectProductBaseVariantOverlayProps): SelectProductBaseVariantOverlayViewModel {
  const { onSelect } = payload
  const { closeOverlay } = useCurrentOverlay()

  const selectPreset = useEvent(() => {
    onSelect()
    closeOverlay()
  })

  return { closeOverlay, selectPreset }
}
